// hooks/useTypewriter.js
import { useState, useEffect } from 'react';

export const useTypewriter = (text, speed = 100, deleteSpeed = 50, pauseTime = 2000) => {
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);

  useEffect(() => {
    let timer;

    const handleType = () => {
      const fullText = text;
      
      if (!isDeleting) {
        // Escribiendo letra por letra
        if (displayText.length < fullText.length) {
          setDisplayText(fullText.substring(0, displayText.length + 1));
          timer = setTimeout(handleType, speed);
        } else {
          // Terminó de escribir, pausar antes de borrar
          timer = setTimeout(() => setIsDeleting(true), pauseTime);
        }
      } else {
        // Borrando letra por letra
        if (displayText.length > 0) {
          setDisplayText(fullText.substring(0, displayText.length - 1));
          timer = setTimeout(handleType, deleteSpeed);
        } else {
          // Terminó de borrar, empezar de nuevo
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
        }
      }
    };

    timer = setTimeout(handleType, isDeleting ? deleteSpeed : speed);

    return () => clearTimeout(timer);
  }, [displayText, isDeleting, text, speed, deleteSpeed, pauseTime, loopNum]);

  return displayText;
};
